import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

//Vuex.Store 构造器选项
const store = new Vuex.Store({
  // 存放状态
  state: {
    "totalEnable": undefined, // 新增模块-总启用-开关
    "coilingId": 0, // 新增模块-选中的套卷id
    "fieldsJSON": [], // 新增模块-选中的套卷-栏位数据
    "isTreeShow": true, // 新增模块-显示题目编号
    "regionId": '', //当前地区信息
    "bookId": '', //当前题源信息
    "catalogType": '', //当前模块类型信息
    "catalogId": '',  //当前模块类型id
    "userInfo": {},
    "pageNum":'', //当前页面的编号 1：听说图书；2：听说精练
    "testContent": '',//当前试题内容
    "processContent": '',//当前流程内容
    "moduleType": '',  //模块类型
    "moduleList": {}  //模块列表
  },
  // 对state的加工，是派生出来的数据。
  getters: {

  },
  // 改变数据的方法集合，处理数据逻辑的方法
  mutations: {
    // 新增模块-总启用-赋值
    totalEnableChange(state, value) {
      state.totalEnable = value;
    },

    // 新增模块-选中的套卷id-赋值
    coilingIdChange(state, value) {
      state.coilingId = value;
    },

    // 新增模块-栏位数据-赋值
    fieldsJSONChange(state, value) {
      state.fieldsJSON = value;
    },

    // 新增模块-显示题目编号-变化
    isTreeShowChange(state, value) {
      state.isTreeShow = value;
    },
    //更新当前地区信息
    updateRegionId(state, value) {
      state.regionId = value;
    },
    //更新当前题源信息
    updatebookId(state, value) {
      state.bookId = value;
    },
    //更新当前模块类型信息
    updateCatalogType(state, value) {
      state.catalogType = value;
    },
    //更新当前模块类型信息
    updateCatalogId(state, value) {
      state.catalogId = value;
    },
    //更新用户信息
    updateUserInfo(state, value) {
      state.userInfo = value;
    },
    //更新试题内容
    updateTestContent(state, value) {
      state.testContent = value;
    },
    //更新流程内容
    updateProcessContent(state, value) {
      state.processContent = value;
    },
    //更新模块类型内容
    updateModuleType(state, value) {
      state.moduleType = value;
    },
    //更新模块类型内容
    updateModuleList(state, value) {
      state.moduleList = value;
    }
  }
})
export default store